<template>
  <div class="studentifno-addstudent-upload">
    <div class="select-module">
      <div class="sensitiveWord-select-t">
        <el-select v-model="ruleForm.gradeId" placeholder="选择年级" @change="selectGrade" clearable>
          <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName" :value="item.gradeId">
          </el-option>
        </el-select>
      </div>
      <!-- 选择班级 -->
      <div class="sensitiveWord-select-t">
        <el-select v-model="ruleForm.classId" placeholder="选择班级" @change="selectClass" clearable>
          <el-option v-for="item in classSelectList" :key="item.classId" :label="item.className" :value="item.classId">
          </el-option>
        </el-select>
      </div>
      <!-- 学生状态 -->
      <div class="sensitiveWord-select-t">
        <el-select v-model="ruleForm.studentType" placeholder="学生状态" clearable>
          <el-option v-for="item in studentTypeList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 上传模块 -->
    <div class="upload-module">
      <div class="module-title">上传XLSX表格</div>
      <el-upload ref="upload" action="https://jsonplaceholder.typicode.com/posts/" :on-change="onChange"
        class="upload-demo" drag multiple :auto-upload="false" accept=".xls,.xlsx">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 预览模块 -->
    <!-- <div class="preview-module">
      <div class="module-title">预览</div>
      <div class="preview-table">
        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%; max-height: 300px; overflow-y: auto"
          :data="tableData">
          <el-table-column label="#" type="index"> </el-table-column>
          <el-table-column prop="studentName" label="姓名"> </el-table-column>
          <el-table-column prop="studentNumber" label="学号"> </el-table-column>
          <el-table-column prop="sex" label="性别"> </el-table-column>
          <el-table-column prop="duty" label="班级职务"> </el-table-column>
          <el-table-column prop="politicsStatus" label="政治面貌"> </el-table-column>
          <el-table-column prop="class" label="年级班级">
            {{ classData[0].gradeName + classData[1].className }}
          </el-table-column>
          <el-table-column label="家庭地址" :show-overflow-tooltip="true" prop="address">
          </el-table-column>
        </el-table>
      </div>
    </div> -->
    <!-- 确认上传到服务器 -->
    <div class="confirm-module">
      <el-button type="primary" :loading="submitButtonLoading" @click="upload">{{
        submitButtonLoading ? "上传中" : "确认上传"
      }}</el-button>
      <!-- 下载模版 -->
      <el-button type="success" @click="uploadXlsxModule" v-hasPermi="'sc:student:add'">
        下载模版
      </el-button>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { baseURL } from "@/api/request";
import axios from "axios";
export default {
  data() {
    return {
      submitButtonLoading: false,
      tableData: [],
      class: [],
      ruleForm: {
        classId: "",
        className: "",
        gradeId: "",
        gradeName: "",
        studentType: "",
      },
      classSelectList: [],
      file: ''
    };
  },
  inject: ["standard",],
  props: ["gradeSelectList", "studentTypeList"],
  methods: {
    // 切换年级
    selectGrade(e) {
      // console.log(e);
      this.ruleForm.gradeId = e;
      this.ruleForm.classId = "";
      this.ruleForm.className = "";
      this.ruleForm.gradeName = this.gradeSelectList.find(item => item.gradeId == e).gradeName;
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.classSelectList = [];
      }
    },
    selectClass(e) {
      if (e != '') {
        this.ruleForm.className = this.classSelectList.find(item => item.classId == e).className;
      } else {
        this.ruleForm.className = '';
      };
      this.ruleForm.classId = e;
    },
    // 下载模板
    uploadXlsxModule() {
      window.open(`${baseURL}${this.$url.getStudentExport}`);
    },
    rimData(data) {
      return data.map(item => {
        const newItem = {};
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            // 如果值是字符串，则去除其首尾空格以及中间多余的空格
            if (typeof item[key] === 'string') {
              // 去除首尾空格
              let trimmedValue = item[key].trim();
              // 去除字符串内部多余空格
              trimmedValue = trimmedValue.replace(/\s+/g, ' ');
              newItem[key] = trimmedValue;
            } else {
              // 如果不是字符串，直接复制值
              newItem[key] = item[key];
            }
          }
        }
        return newItem;
      });
    },
    onChange(file, fileList) {
      // console.log(file);
      // console.log(fileList);
      let file_type = file.name.split(".")[1];
      if (!/^(xls|xlsx)$/g.test(file_type)) {
        return this.$message.error("只能选择xlsx或xls类型文件");
      } else {
        this.file = file.raw;
        //是xlsx，xls文件,读取文件数据
        this.readFileData(file.raw, (workbook) => {
          this.readWorkbook(workbook);
        });
      }
    },
    readFileData(file) {
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // console.log(ws);
          this.studentInfoPreviewTableInit(ws);
        } catch (e) {
          console.error(e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    studentInfoPreviewTableInit(unmodifiedTableData) {
      // console.log("unmodifiedTableData==>", unmodifiedTableData);
      this.tableData = [];
      unmodifiedTableData.forEach((item, index) => {
        let template = {};
        for (let standardItem of this.standard) {
          const value = item[standardItem.label];
          // 去除字符串字段的首尾空格和内部多余空格
          const trimmedValue = typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : value;
          template[standardItem.field] = trimmedValue;
        }
        this.tableData.push(JSON.parse(JSON.stringify(template)));
        // console.log(this.tableData);
      });
    },
    // 上传
    upload() {
      if (this.ruleForm.gradeId == "" || this.ruleForm.studentType == "") {
        return this.$message.warning("请选择年级和学生状态");
      };
      if (this.tableData.length == 0) {
        return this.$message.warning("请添加数据");
      }
      if (this.submitButtonLoading) {
        return this.$message.warning("上传中，请勿重复点击");
      }
      let { schoolId, schoolName } = this.user;
      let { gradeId, gradeName, classId, className, studentType } = this.ruleForm;
      let action = `${baseURL}${this.$url.uploadStudent}`;
      // new FormData()创建创建FormData对象
      this.formData = new FormData();
      // this.$refs.upload.submit(); // => 会调用uploadFile(file)

      // 向FormData对象设置其他参数
      // console.log(user);
      this.formData.append("schoolId", schoolId);
      this.formData.append("schoolName", schoolName);
      this.formData.append("gradeName", gradeName);
      this.formData.append("gradeId", gradeId);
      this.formData.append("status", studentType)
      this.formData.append("file", this.file);
      if (classId) {
        this.formData.append("classId", classId);
        this.formData.append("className", className);
      };
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };
      // console.log("配置", this.action, this.formData, config);
      // 调用接口
      axios
        .post(action, this.formData, config)
        .then((res) => {
          console.log(res);
          // res.data 服务器返回的数据
          let data = res.data;
          if (data.code == 200) {
            this.$message.success("上传成功");
            this.$emit("uploadSuccess", data.data || []);
          } else {
            this.$message.error(data.msg);
          }
          this.submitButtonLoading = false;
        })
        .catch((res) => {
          this.submitButtonLoading = false;
        });
      // this.tableData.map((item) => {
      //   item.createBy = this.user.id;
      //   item.schoolId = schoolId;
      //   item.schoolName = schoolName;
      //   item.gradeId = gradeId;
      //   item.gradeName = gradeName;
      //   item.classId = classId;
      //   item.className = className;
      // });
      // console.log(this.tableData);
      // this.post(this.$url.insertStudentPC, this.tableData)
      //   .then((res) => {
      //     // console.log(res);
      //     if (res.code == 200) {
      //       this.$message.success("上传成功");
      //       this.$emit("uploadSuccess", res.data || []);
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //     this.submitButtonLoading = false;
      //   })
      //   .catch((err) => {
      //     this.submitButtonLoading = false;
      //     // this.$message.error("上传失败，请稍后再试");
      //   });
    },
    reset() {
      this.tableData = [];
    },
  },
};
</script>

<style scoped lang="scss">
@import "./studentifno-addstudent-upload.scss";
</style>
